// Footer.js
import React from 'react';
import { Box, Link, Typography } from '@mui/material';

const Footer = ({ landing = false }) => {
  return (
    <Box
      component="footer"
      sx={{
        // mt: 4,
        pt: 4,
        pb:4,
        paddingLeft: {xs:landing? 0 : '15%', sm:landing? '5%' : '10%', lg:'5%'},
        background:'#f9f9f9',
        textAlign: 'center',
        display:'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent:'space-between',
        width: {xs:'100%', sm:landing? '90%' : '95%', md:landing? '90%' : '95%', lg:landing? '90%' :'100%'},
        // marginLeft: {xs:'auto'},
        '@media (orientation: landscape) and (max-height: 450px)': {
        marginLeft:'5%',
        paddingLeft:landing? 0:'3%',
        },
      }}
    >
      <div>
        <Typography variant="body2" sx={{
    ml: { xs: '15px', md: '30px' },
  }}>
        &copy; 2026 Medicheck. All Rights Reserved.
        </Typography>
      </div>
      <div>
      <Typography variant="body2">
        <Link href="/terms-and-conditions" underline="hover" sx={{ mx: 1, fontSize:{xs:'12px', md:'14px'}}}>
          Terms & Conditions
        </Link>
        |
        <Link href="/privacy-policy" underline="hover" sx={{ mx: 1, fontSize:{xs:'12px', md:'14px'}}}>
          Privacy Policy
        </Link>
        |
        <Link href="/refund-policy" underline="hover" sx={{ mx: 1, xs:'12px', fontSize:{xs:'12px', md:'14px'}}}>
          Refund Policy
        </Link>
      </Typography>
      </div>
      <div>
        <Typography variant="body2" sx={{mr: { xs: '15px', md: '30px'}}}>
        A product of <Link href="https://www.visiongridlabs.com" target="blank" style={{textDecoration:'none'}}>Vision Grid</Link>
        </Typography>
      </div>
    </Box>
  );
};

export default Footer;
